module.exports = __webpack_public_path__ + "img/179.5cbed42a.jpg";